import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const {pathname, hash} = useLocation();

  useEffect(() => {
    const scrollContainer = document.getElementById("content") || document.documentElement;

    if (hash) {
      window.setTimeout(() => {
        const element = document.getElementById(decodeURIComponent(hash.replace("#", "")));

        if (element) {
          element.scrollIntoView({
            behavior: "auto",
            block: "start",
          });
        }
      }, 0);

      return;
    }

    scrollContainer.scrollTo({
      top: 0,
      left: 0,
    });
  }, [pathname, hash]);

  return null;
}

export default ScrollToTop;
